import { TCondition } from '../types';
import { IApplicationState } from '../../../../types/types';
import { getActiveBoardId } from '../../../../store/model/selectors/getActiveBoardId';
import { EHintKey, getHintConfig } from '../constants';
import { CLASS_COLOR_TAGS_DROPDOWN } from '../../base/components/ColorTagsDropdown/constants';

export const kanbanColorTagsScrollUpCondition: TCondition = (
    state: IApplicationState
) => {
    const hint = getHintConfig(EHintKey.KANBAN_COLOR_TAGS_SCROLL_UP);
    if (!hint) return false;

    const search = document.querySelector(`.${CLASS_COLOR_TAGS_DROPDOWN}__input`) as HTMLElement;
    if(!search) return false;

    return !!getActiveBoardId(state);
};
